<template>
  <div style="display: inline-block">
    

  

    <router-link v-if="href" :to="user && user.id ? `/u/${user.id}` : '/u/0'">
      <el-avatar
        :shape="shape"
        :size="size"
        fit="fill"
        :src="
          user && user.avatar
            ? url + user.avatar
            : 'https://www.wch.cn/uploads/avatar/head.gif'
        "
      ></el-avatar>
    </router-link>
    

    <el-avatar
      v-else
      :shape="shape"
      :size="size"
      fit="fill"
      :src="
        user && user.avatar
          ? url + user.avatar
          : 'https://www.wch.cn/uploads/avatar/head.gif'
      "
    ></el-avatar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "",
    };
  },
  created() {
    this.url = process.env.VUE_APP_IMG_API + "/avatar/";
  },
  props: {
    size: {
      required: true,
    },
    user: {
      required: true,
    },
    shape: {
      type: String,
      default: "square",
    },
    href: {
      type:Boolean,
      default: true,
    },
  },
};
</script>
